import React, {
	Component
} from "react";
import xtend from "xtend";

import InputLabel from "../Layout/InputLabel";
import InputContainer from "../Layout/InputContainer";
import inputStyle from "../Layout/intputStyle";
import ErrorMessage from "../Layout/ErrorMessage";

import { useResources, useIdPrefix } from "@aetonix/hooks";

class DatePickerWebComp extends Component {
	constructor(props){
		super(props);

		this.state = {
			newValue: null
		};

		this.handleChange = handleChange.bind(this);
	}

	render(){
		const props = this.props;
		const schema = props.schema;
		const errors = props.errors;
		let defaultValue = props.defaultValue;

		const localize = props.localize;
		const localizeFrom = props.localizeFrom;

		if(defaultValue)
			defaultValue = defaultValue.substring(0, 10);

		let pickerStyle = inputStyle.raw;

		let label;
		if(schema !== undefined && schema.localization){
			label = localizeFrom(schema.localization, ".");
		} else if(schema !== undefined && schema.description) {
			label = localize(schema.description);
		} else {
			label = "Pick a Date";
		}

		if(errors && errors.length){
			pickerStyle = xtend(pickerStyle, inputStyle.errored);
		}

		return (
			<InputContainer inline={props.inline}>
				<InputLabel schema={schema} />
				<ErrorMessage id={this.props.id + "_error"} errors={errors} schema={schema} />
				<input
					type="date"
					aria-label={label || "Pick a Date"}
					id={props.id_prefix + props.id}
					value={defaultValue || "MM/DD/YYYY"}
					style={pickerStyle}
					onChange={this.handleChange}
					max={schema.maxDate?.toISOString().split("T")[0]}
				/>
			</InputContainer>
		);
	}
}

function handleChange(event) {
	const value = event.target.valueAsDate;
	const onChange = this.props.onChange;
	value?.setUTCHours(value?.getUTCHours() + ( (value?.getTimezoneOffset() / 60) >= 0 ? (value?.getTimezoneOffset() / 60) : null  ));
	if(onChange) onChange(value?.toISOString());
	this.setState({
		newValue: value
	});
}

export default function DatePickerWeb(props) {
	const { localize, localizeFrom } = useResources();
	const idPrefix = useIdPrefix();
	return (
		<DatePickerWebComp {...props} idPrefix={idPrefix} localize={localize} localizeFrom={localizeFrom} />
	);
}